document.addEventListener("DOMContentLoaded", function () {
	const anchorLinks = document.querySelectorAll(".anchor-link");

	anchorLinks.forEach(function (link) {
		let anchorID = "";
		if (link.classList.contains("anchor-section")) {
			anchorID = link.id;
		} else {
			anchorID = link.textContent.trim().replace(/\s+/g, "");
			anchorID = anchorID.replace(/^[^a-zA-Z]+/, "");
		}

		if (anchorID) {
			if (!link.classList.contains("anchor-section")) {
				link.id = anchorID;
			}

			const anchorLink = window.location.href.split("#")[0] + "#" + anchorID;

			link.onclick = function (event) {
				event.preventDefault();
				event.stopPropagation();
				navigator.clipboard
					.writeText(anchorLink)
					.then(function () {
						window.location.hash = anchorID;

						const targetElement = document.getElementById(anchorID);
						if (targetElement) {
							targetElement.scrollIntoView({ behavior: "smooth" });
						}

						bootstrap.Toast.getOrCreateInstance(document.querySelector("#copyToast")).show();
					})
					.catch(function (error) {
						console.error("Error copying the link to clipboard: ", error);
					});
			};
		}
	});

	const initialHash = window.location.hash;
	if (initialHash) {
		const initialElement = document.querySelector(initialHash);
		if (initialElement) {
			initialElement.scrollIntoView({ behavior: "smooth" });
		}
	}
});

function openAccordionAndScrollToHash(hash) {
	if (!hash) return;
	const target = document.querySelector(hash);
	if (!target) return;

	// Check if target is an accordion button (has accordion-button class)
	const isAccordionButton = target.classList.contains("accordion-button") && target.tagName !== "A";
	
	// Find the collapse element - either the target itself (if it's content) or the parent collapse (if it's a button)
	let collapseEl;
	if (isAccordionButton) {
		// If it's a button, find the associated collapse element
		const buttonId = target.id;
		const accordionItem = target.closest(".accordion-item");
		if (accordionItem) {
			collapseEl = accordionItem.querySelector(".collapse");
		}
	} else {
		// If it's content, find the closest collapse element
		collapseEl = target.closest(".collapse");
	}

	if (collapseEl && !collapseEl.classList.contains("show")) {
		const bsCollapse = new bootstrap.Collapse(collapseEl, {
			toggle: false,
		});
		bsCollapse.show();

		collapseEl.addEventListener("shown.bs.collapse", function handler() {
			// Only run once
			collapseEl.removeEventListener("shown.bs.collapse", handler);
			setTimeout(() => {
				target.scrollIntoView({ behavior: "smooth", block: "start" });
			}, 50);
		});
	} else {
		setTimeout(() => {
			target.scrollIntoView({ behavior: "smooth", block: "start" });
		}, 50);
	}
}

document.addEventListener("DOMContentLoaded", function () {
	if (window.location.hash) {
		openAccordionAndScrollToHash(window.location.hash);
	}

	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			if (this.hash === window.location.hash) {
				e.preventDefault();
				openAccordionAndScrollToHash(this.hash);
			}
		});
	});
});

window.addEventListener("hashchange", function () {
	openAccordionAndScrollToHash(window.location.hash);
});

function getFixedHeaderOffsetPx() {
	const header = document.querySelector(".site-header");
	if (!header) {
		return 0;
	}

	const position = window.getComputedStyle(header).position;
	if (position !== "fixed" && position !== "sticky") {
		return 0;
	}

	// Sit flush under the header so collapsing content above is hidden.
	return Math.ceil(header.getBoundingClientRect().height);
}

let accordionScrollFrame = 0;
let accordionScrollBehavior = null;

function stopAccordionPin() {
	if (accordionScrollFrame) {
		window.cancelAnimationFrame(accordionScrollFrame);
		accordionScrollFrame = 0;
	}

	if (accordionScrollBehavior !== null) {
		document.documentElement.style.scrollBehavior = accordionScrollBehavior;
		accordionScrollBehavior = null;
	}
}

function scrollWindowInstant(top) {
	window.scrollTo(window.scrollX, top);
}

function pinAccordionHeader(header, accordion) {
	stopAccordionPin();

	const root = document.documentElement;
	accordionScrollBehavior = root.style.scrollBehavior;
	root.style.scrollBehavior = "auto";

	const offset = getFixedHeaderOffsetPx();
	const startedAt = performance.now();

	function stopOnUserScroll() {
		stopAccordionPin();
		window.removeEventListener("wheel", stopOnUserScroll);
		window.removeEventListener("touchmove", stopOnUserScroll);
		window.removeEventListener("keydown", stopOnUserScroll);
	}

	window.addEventListener("wheel", stopOnUserScroll, { passive: true });
	window.addEventListener("touchmove", stopOnUserScroll, { passive: true });
	window.addEventListener("keydown", stopOnUserScroll);

	function pin() {
		const diff = header.getBoundingClientRect().top - offset;
		if (Math.abs(diff) >= 1) {
			scrollWindowInstant(window.scrollY + diff);
		}
	}

	function finish() {
		pin();
		accordionScrollFrame = 0;
		if (accordionScrollBehavior !== null) {
			root.style.scrollBehavior = accordionScrollBehavior;
			accordionScrollBehavior = null;
		}
		window.removeEventListener("wheel", stopOnUserScroll);
		window.removeEventListener("touchmove", stopOnUserScroll);
		window.removeEventListener("keydown", stopOnUserScroll);
	}

	function step() {
		pin();
		const stillAnimating = accordion.querySelector(".collapsing");
		const elapsed = performance.now() - startedAt;
		if (stillAnimating || elapsed < 50) {
			accordionScrollFrame = window.requestAnimationFrame(step);
			return;
		}

		finish();
	}

	pin();
	accordionScrollFrame = window.requestAnimationFrame(step);
}

document.addEventListener("show.bs.collapse", function (event) {
	const panel = event.target;
	if (!(panel instanceof Element) || !panel.classList.contains("accordion-collapse")) {
		return;
	}

	const accordion = panel.closest(".content-accordion .accordion");
	if (!accordion) {
		return;
	}

	const header = panel.closest(".accordion-item")?.querySelector(".accordion-header");
	if (!header) {
		return;
	}

	pinAccordionHeader(header, accordion);
});
